import { Children, Component } from 'react';

// Taken from https://github.com/ryanseddon/react-frame-component
export default class Content extends Component {
  componentDidMount() {
    this.props.contentDidMount();
  }

  componentDidUpdate() {
    this.props.contentDidUpdate();
  }

  render() {
    return Children.only(this.props.children);
  }
}
